import { spErrorTags, spLogTags } from "@eventr/common";
import { createLocalStore } from "./local-forage-store";

export interface LocalStoreItem<T> {
  storeId: string;
  retries: number;
  firstUploadDate: Date;
  data: T;
}

const DB_NAME = "local-cache-store";

export function createLocalCacheStore<T>(storeName: string, getId: (data: T) => string) {
  const store = createLocalStore<LocalStoreItem<T>>(DB_NAME, storeName);

  return {
    async save(data: T) {
      const storeId = getId(data);
      const existing = await store.get(storeId);

      const item: LocalStoreItem<T> = {
        storeId,
        retries: existing?.retries ?? 0,
        firstUploadDate: existing?.firstUploadDate ?? new Date(),
        data,
      };
      await store.set(storeId, item);
    },

    getAll: store.getAll,
    get: store.get,
    remove: store.remove,

    incrementRetry: async (item: LocalStoreItem<T>) => {
      try {
        const incrementedItem: LocalStoreItem<T> = { ...item, retries: item.retries + 1 };
        await store.set(item.storeId, incrementedItem);

        spLogTags(`[${storeName}] ${item.storeId} retries → ${incrementedItem.retries}`, [storeName]);
      } catch (err) {
        spErrorTags(`[${storeName}] ${item.storeId} → failed to increment retries`, [storeName], err);
      }
    },
  };
}
